// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file tracker/v1/common.proto (package tracker.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";

/**
 * @generated from enum tracker.v1.SortOrder
 */
export enum SortOrder {
  /**
   * @generated from enum value: SORT_ORDER_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: SORT_ORDER_ASC = 1;
   */
  ASC = 1,

  /**
   * @generated from enum value: SORT_ORDER_DESC = 2;
   */
  DESC = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(SortOrder)
proto3.util.setEnumType(SortOrder, "tracker.v1.SortOrder", [
  { no: 0, name: "SORT_ORDER_UNSPECIFIED" },
  { no: 1, name: "SORT_ORDER_ASC" },
  { no: 2, name: "SORT_ORDER_DESC" },
]);

/**
 * ResourceKind identifies the polymorphic target of cross-cutting concerns
 * (tags, audit log, tag-manager snippet scope).
 *
 * @generated from enum tracker.v1.ResourceKind
 */
export enum ResourceKind {
  /**
   * @generated from enum value: RESOURCE_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: RESOURCE_KIND_WORKSPACE = 1;
   */
  WORKSPACE = 1,

  /**
   * @generated from enum value: RESOURCE_KIND_TRAFFIC_SOURCE = 2;
   */
  TRAFFIC_SOURCE = 2,

  /**
   * @generated from enum value: RESOURCE_KIND_AFFILIATE_NETWORK = 3;
   */
  AFFILIATE_NETWORK = 3,

  /**
   * @generated from enum value: RESOURCE_KIND_OFFER = 4;
   */
  OFFER = 4,

  /**
   * @generated from enum value: RESOURCE_KIND_LANDER = 5;
   */
  LANDER = 5,

  /**
   * @generated from enum value: RESOURCE_KIND_CAMPAIGN = 6;
   */
  CAMPAIGN = 6,

  /**
   * @generated from enum value: RESOURCE_KIND_FLOW = 7;
   */
  FLOW = 7,

  /**
   * @generated from enum value: RESOURCE_KIND_FLOW_TEMPLATE = 8;
   */
  FLOW_TEMPLATE = 8,

  /**
   * @generated from enum value: RESOURCE_KIND_TRACKING_DOMAIN = 9;
   */
  TRACKING_DOMAIN = 9,

  /**
   * @generated from enum value: RESOURCE_KIND_INTEGRATION = 10;
   */
  INTEGRATION = 10,

  /**
   * @generated from enum value: RESOURCE_KIND_TAG_MANAGER_SNIPPET = 11;
   */
  TAG_MANAGER_SNIPPET = 11,

  /**
   * @generated from enum value: RESOURCE_KIND_ALERT_RULE = 13;
   */
  ALERT_RULE = 13,

  /**
   * @generated from enum value: RESOURCE_KIND_RULE = 14;
   */
  RULE = 14,

  /**
   * @generated from enum value: RESOURCE_KIND_CONTENT_SET = 15;
   */
  CONTENT_SET = 15,
}
// Retrieve enum metadata with: proto3.getEnumType(ResourceKind)
proto3.util.setEnumType(ResourceKind, "tracker.v1.ResourceKind", [
  { no: 0, name: "RESOURCE_KIND_UNSPECIFIED" },
  { no: 1, name: "RESOURCE_KIND_WORKSPACE" },
  { no: 2, name: "RESOURCE_KIND_TRAFFIC_SOURCE" },
  { no: 3, name: "RESOURCE_KIND_AFFILIATE_NETWORK" },
  { no: 4, name: "RESOURCE_KIND_OFFER" },
  { no: 5, name: "RESOURCE_KIND_LANDER" },
  { no: 6, name: "RESOURCE_KIND_CAMPAIGN" },
  { no: 7, name: "RESOURCE_KIND_FLOW" },
  { no: 8, name: "RESOURCE_KIND_FLOW_TEMPLATE" },
  { no: 9, name: "RESOURCE_KIND_TRACKING_DOMAIN" },
  { no: 10, name: "RESOURCE_KIND_INTEGRATION" },
  { no: 11, name: "RESOURCE_KIND_TAG_MANAGER_SNIPPET" },
  { no: 13, name: "RESOURCE_KIND_ALERT_RULE" },
  { no: 14, name: "RESOURCE_KIND_RULE" },
  { no: 15, name: "RESOURCE_KIND_CONTENT_SET" },
]);

/**
 * BranchTrigger names what sends a visitor into one of a campaign's monetisation
 * BRANCHES (ADR 0002, phase 4) — a sub-graph of its flow with its own lander(s)
 * and/or offers. The page runtime (landing-toolchain studio.js) owns every
 * trigger; the edge publishes each branch's signed address in window.__VT__.
 *
 * @generated from enum tracker.v1.BranchTrigger
 */
export enum BranchTrigger {
  /**
   * @generated from enum value: BRANCH_TRIGGER_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * The browser's Back, caught by the page's gesture-safe history sentinel.
   *
   * @generated from enum value: BRANCH_TRIGGER_BACK = 1;
   */
  BACK = 1,

  /**
   * The page's exit intent (pointer leaving the top edge; the mobile upward fling).
   *
   * @generated from enum value: BRANCH_TRIGGER_EXIT_INTENT = 2;
   */
  EXIT_INTENT = 2,

  /**
   * No input for idle_seconds while the page is visible.
   *
   * @generated from enum value: BRANCH_TRIGGER_IDLE = 3;
   */
  IDLE = 3,

  /**
   * The visitor scrolled to the end of the page.
   *
   * @generated from enum value: BRANCH_TRIGGER_SCROLL_END = 4;
   */
  SCROLL_END = 4,

  /**
   * The second step: the landings a first-step page's button leads to. The
   * page sends the visitor in (window.__VT__.branches.next_step), or the visit
   * re-enters the campaign's path through a CampaignReentry.
   *
   * @generated from enum value: BRANCH_TRIGGER_NEXT_STEP = 5;
   */
  NEXT_STEP = 5,
}
// Retrieve enum metadata with: proto3.getEnumType(BranchTrigger)
proto3.util.setEnumType(BranchTrigger, "tracker.v1.BranchTrigger", [
  { no: 0, name: "BRANCH_TRIGGER_UNSPECIFIED" },
  { no: 1, name: "BRANCH_TRIGGER_BACK" },
  { no: 2, name: "BRANCH_TRIGGER_EXIT_INTENT" },
  { no: 3, name: "BRANCH_TRIGGER_IDLE" },
  { no: 4, name: "BRANCH_TRIGGER_SCROLL_END" },
  { no: 5, name: "BRANCH_TRIGGER_NEXT_STEP" },
]);

/**
 * Ownership names who made a resource (owner_id = the author's Keycloak sub,
 * "" when nobody did — a sourced offer, a platform default) and the tenant it
 * lives in. It never narrows visibility: everyone in the workspace sees and
 * edits every resource. Update RPCs echo the server-provided Ownership back
 * and handlers keep the stored author — the wire value is not trusted.
 *
 * @generated from message tracker.v1.Ownership
 */
export class Ownership extends Message<Ownership> {
  /**
   * @generated from field: string owner_id = 1;
   */
  ownerId = "";

  /**
   * @generated from field: string tenant_id = 3;
   */
  tenantId = "";

  constructor(data?: PartialMessage<Ownership>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.Ownership";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "owner_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "tenant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Ownership {
    return new Ownership().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Ownership {
    return new Ownership().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Ownership {
    return new Ownership().fromJsonString(jsonString, options);
  }

  static equals(a: Ownership | PlainMessage<Ownership> | undefined, b: Ownership | PlainMessage<Ownership> | undefined): boolean {
    return proto3.util.equals(Ownership, a, b);
  }
}

/**
 * Inclusive ISO 8601 date range (YYYY-MM-DD) for stats and reporting.
 *
 * @generated from message tracker.v1.DateRange
 */
export class DateRange extends Message<DateRange> {
  /**
   * @generated from field: string from = 1;
   */
  from = "";

  /**
   * @generated from field: string to = 2;
   */
  to = "";

  /**
   * timezone is an optional IANA zone name (e.g. "Europe/Kyiv") used to
   * interpret from/to day boundaries and date bucketing. Empty means the
   * workspace's own timezone (Workspace.timezone).
   *
   * @generated from field: string timezone = 3;
   */
  timezone = "";

  constructor(data?: PartialMessage<DateRange>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.DateRange";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "from", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "to", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "timezone", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DateRange {
    return new DateRange().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DateRange {
    return new DateRange().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DateRange {
    return new DateRange().fromJsonString(jsonString, options);
  }

  static equals(a: DateRange | PlainMessage<DateRange> | undefined, b: DateRange | PlainMessage<DateRange> | undefined): boolean {
    return proto3.util.equals(DateRange, a, b);
  }
}

/**
 * Offset-based pagination for list endpoints. The 20000 ceiling exists for
 * the reports drilldown and the campaign list, which transfer one big sorted
 * slice (the list's numbers are counted over every campaign for any page);
 * plain list UIs request far less.
 *
 * @generated from message tracker.v1.Pagination
 */
export class Pagination extends Message<Pagination> {
  /**
   * @generated from field: int32 limit = 1;
   */
  limit = 0;

  /**
   * @generated from field: int32 offset = 2;
   */
  offset = 0;

  constructor(data?: PartialMessage<Pagination>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.Pagination";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "limit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "offset", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Pagination {
    return new Pagination().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Pagination {
    return new Pagination().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Pagination {
    return new Pagination().fromJsonString(jsonString, options);
  }

  static equals(a: Pagination | PlainMessage<Pagination> | undefined, b: Pagination | PlainMessage<Pagination> | undefined): boolean {
    return proto3.util.equals(Pagination, a, b);
  }
}

/**
 * The order a catalog list is served in. `field` is one of the list's own
 * sortable fields (named on each request); empty = the list's default order.
 * Every order ends on the row id, so pages of a list never overlap or skip.
 *
 * @generated from message tracker.v1.ListSort
 */
export class ListSort extends Message<ListSort> {
  /**
   * @generated from field: string field = 1;
   */
  field = "";

  /**
   * @generated from field: bool desc = 2;
   */
  desc = false;

  constructor(data?: PartialMessage<ListSort>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ListSort";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "field", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "desc", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListSort {
    return new ListSort().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListSort {
    return new ListSort().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListSort {
    return new ListSort().fromJsonString(jsonString, options);
  }

  static equals(a: ListSort | PlainMessage<ListSort> | undefined, b: ListSort | PlainMessage<ListSort> | undefined): boolean {
    return proto3.util.equals(ListSort, a, b);
  }
}

/**
 * Echo of pagination plus total row count for clients.
 *
 * @generated from message tracker.v1.PaginationMeta
 */
export class PaginationMeta extends Message<PaginationMeta> {
  /**
   * @generated from field: int32 total = 1;
   */
  total = 0;

  /**
   * @generated from field: int32 limit = 2;
   */
  limit = 0;

  /**
   * @generated from field: int32 offset = 3;
   */
  offset = 0;

  constructor(data?: PartialMessage<PaginationMeta>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.PaginationMeta";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "total", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "limit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "offset", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PaginationMeta {
    return new PaginationMeta().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PaginationMeta {
    return new PaginationMeta().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PaginationMeta {
    return new PaginationMeta().fromJsonString(jsonString, options);
  }

  static equals(a: PaginationMeta | PlainMessage<PaginationMeta> | undefined, b: PaginationMeta | PlainMessage<PaginationMeta> | undefined): boolean {
    return proto3.util.equals(PaginationMeta, a, b);
  }
}

/**
 * FieldError reports a single validation failure in a structured form so the
 * FE editor can paint inline errors next to the offending field / node / edge.
 * Shared by ValidateFlow and ValidateRule (and attached as connect error
 * metadata via the X-Field header on save).
 *
 * @generated from message tracker.v1.FieldError
 */
export class FieldError extends Message<FieldError> {
  /**
   * Dotted path: "name", "nodes[2].weight", "condition.children[1].codes", etc.
   *
   * @generated from field: string path = 1;
   */
  path = "";

  /**
   * Stable code: NAME_REQUIRED, CYCLE_DETECTED, CONDITION_REQUIRED,
   * METRIC_LEAF_IN_CLICK_RULE, NOTIFY_REQUIRED, WEIGHT_OUT_OF_RANGE, etc.
   *
   * @generated from field: string code = 2;
   */
  code = "";

  /**
   * @generated from field: string message = 3;
   */
  message = "";

  constructor(data?: PartialMessage<FieldError>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.FieldError";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FieldError {
    return new FieldError().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FieldError {
    return new FieldError().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FieldError {
    return new FieldError().fromJsonString(jsonString, options);
  }

  static equals(a: FieldError | PlainMessage<FieldError> | undefined, b: FieldError | PlainMessage<FieldError> | undefined): boolean {
    return proto3.util.equals(FieldError, a, b);
  }
}

/**
 * Money is an ISO-4217 currency-tagged decimal string ("12.34"). The string
 * representation avoids float drift across language boundaries and is what
 * goes onto the wire and into Postgres.
 *
 * @generated from message tracker.v1.Money
 */
export class Money extends Message<Money> {
  /**
   * @generated from field: string amount = 1;
   */
  amount = "";

  /**
   * @generated from field: string currency = 2;
   */
  currency = "";

  constructor(data?: PartialMessage<Money>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.Money";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "amount", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Money {
    return new Money().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Money {
    return new Money().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Money {
    return new Money().fromJsonString(jsonString, options);
  }

  static equals(a: Money | PlainMessage<Money> | undefined, b: Money | PlainMessage<Money> | undefined): boolean {
    return proto3.util.equals(Money, a, b);
  }
}

/**
 * TagRef is the inline form used in list rows; the full Tag aggregate lives in
 * tag.proto. We keep the inline form lean to avoid bloating list responses.
 *
 * @generated from message tracker.v1.TagRef
 */
export class TagRef extends Message<TagRef> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string name = 2;
   */
  name = "";

  /**
   * @generated from field: string color = 3;
   */
  color = "";

  constructor(data?: PartialMessage<TagRef>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.TagRef";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "color", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TagRef {
    return new TagRef().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TagRef {
    return new TagRef().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TagRef {
    return new TagRef().fromJsonString(jsonString, options);
  }

  static equals(a: TagRef | PlainMessage<TagRef> | undefined, b: TagRef | PlainMessage<TagRef> | undefined): boolean {
    return proto3.util.equals(TagRef, a, b);
  }
}

